import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getCustomerReports } from 'src/redux/customerreports'
import {
  CRow,
  CCol,
  CTable,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell,
  CBadge,
} from '@coreui/react'

const CustomerReports = () => {
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const dispatch = useDispatch()
  const { customerReportsData } = useSelector((state) => state.customerreports)

  useEffect(() => {
    const today = new Date()
    const thirtyDaysAgo = new Date()
    thirtyDaysAgo.setDate(today.getDate() - 30)

    const formattedToday = today.toISOString().split('T')[0]
    const formattedThirtyDaysAgo = thirtyDaysAgo.toISOString().split('T')[0]

    setStartDate(formattedThirtyDaysAgo)
    setEndDate(formattedToday)
  }, [])

  useEffect(() => {
    if (startDate && endDate) {
      dispatch(getCustomerReports(startDate, endDate))
    }
  }, [dispatch, startDate, endDate])

  return (
    <CTable striped hover responsive bordered>
      <CTableHead className="table-dark">
        <CTableRow>
          <CTableHeaderCell>#</CTableHeaderCell>
          <CTableHeaderCell>Username</CTableHeaderCell>
          <CTableHeaderCell>Full Name</CTableHeaderCell>
          <CTableHeaderCell>Mobile No</CTableHeaderCell>
          <CTableHeaderCell>City</CTableHeaderCell>
          <CTableHeaderCell className="text-center">Orders</CTableHeaderCell>
          <CTableHeaderCell className="text-center">Status</CTableHeaderCell>
          <CTableHeaderCell className="text-center">Coupons</CTableHeaderCell>
          <CTableHeaderCell className="text-center">Delivery</CTableHeaderCell>
          <CTableHeaderCell className="text-center">Purchased Products</CTableHeaderCell>
          <CTableHeaderCell className="text-center">Total Spent</CTableHeaderCell>
        </CTableRow>
      </CTableHead>
      <CTableBody>
        {customerReportsData?.map((customer, index) => (
          <CTableRow key={index}>
            <CTableDataCell>{index + 1}</CTableDataCell>
            <CTableDataCell>{customer.username}</CTableDataCell>
            <CTableDataCell>{customer.full_name}</CTableDataCell>
            <CTableDataCell>{customer.mobile_no}</CTableDataCell>
            <CTableDataCell>{customer.city}</CTableDataCell>
            <CTableDataCell className="text-center fw-bold">{customer.total_orders}</CTableDataCell>
            <CTableDataCell className="text-center fw-bold">
              <CBadge
                color={customer.order_status === 'completed' ? 'success' : 'danger'}
                className="text-uppercase"
              >
                {customer.order_status}
              </CBadge>
            </CTableDataCell>
            <CTableDataCell className="text-center">
              <CBadge color="secondary" className="text-black">
                ₹{customer.coupons_discount}
              </CBadge>
            </CTableDataCell>
            <CTableDataCell className="text-center">
              <CBadge color="warning" className="text-black">
                ₹{customer.delivery_charges}
              </CBadge>
            </CTableDataCell>
            <CTableDataCell>
              <ul className="m-0">
                <li className="m-0">
                  <strong>#{customer.order_no}</strong> -{' '}
                  <strong>{new Date(customer.order_date).toLocaleDateString()}</strong>
                </li>
                {customer.purchased_products.map((product, pIndex) => (
                  <li key={pIndex} className="text-muted">
                    <CRow>
                      <CCol md={9} sm={8}>
                        {product.product_name}
                      </CCol>
                      <CCol md={3} sm={4}>
                        {product.quantity} x ₹{product.product_price}
                      </CCol>
                    </CRow>
                  </li>
                ))}
              </ul>
            </CTableDataCell>
            <CTableDataCell className="text-center fw-bold">₹{customer.total_spent}</CTableDataCell>
          </CTableRow>
        ))}
      </CTableBody>
    </CTable>
  )
}

export default CustomerReports
